// src/MyAccount.js
import './asset/App.css';
import Header from './component/Header';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

function FormPage() {
    //const navigate = useNavigate();
    const [formData, setFormData] = useState(false); 
    const [companyName, setCompanyName] = useState(""); 
    const [idReadOnly, setReadOnly] = useState(true); 

    const [emailValue, setEmailValue] = useState(""); 
    const [fullNameValue, setFullNameValue] = useState(""); 

    useEffect(() => {
        axios.get(`https://macct.tw/api/profile`)
        .then((response) => {
            if (response.data.success) {
            console.log(response.data);
            setFormData(response.data.data);
            setEmailValue(response.data.data.username);
            setFullNameValue(response.data.data.fullName);
            } else {
                console.log(response.data);
                alert("發生錯誤:"+response.data.message);
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }, []);
    /*
    useEffect(() => {
        if(!formData){return 0;}
        axios.get(`https://data.gcis.nat.gov.tw/od/data/api/5F64D864-61CB-4D0D-8AD9-492047CC1EA6?$format=json&$filter=Business_Accounting_NO eq ${formData.companyId}&$skip=0&$top=50`)
        .then((response) => {
            if (response.data) {
                console.log(response.data);
                setFormData(response.data[0].Company_Name);
            } else {
                console.log(response.data);
                alert("發生錯誤:"+response.data.message);
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }, [formData]);
    */

    
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    switch (name) {
        case 'email':
            setEmailValue(value);
          break;
        case 'fullName':
            setFullNameValue(value);
          break;
      }
    };


    const handleProfileChange = (event) => {
        event.preventDefault();
        /*
        const formData = new FormData();
        formData.append("fullName", document.getElementById("fullName").value);
        formData.append("email", document.getElementById("email").value);

        console.log(formData.get("fullName"));
        console.log(formData.get("email"));
        */

        const formData = {
            fullName: document.getElementById("fullName").value,
            email: document.getElementById("email").value,
        }

        fetch('https://macct.tw/api/userUpdate', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'credentials': 'include'
            },
            body: JSON.stringify(formData),
        })
        .then(response => response.json())
        .then(data => {
        console.log(data);
        if(data.success){
            alert("更新成功");
            window.location.reload();
        }else{
            alert("更新失敗 \n \n",data.message);
        }
        })
        .catch(error => {
        console.error('Error:', error);
        });

      };

    const handleModify = (check) => {
        console.log(check);
        if(check){
            setReadOnly(false);
        }else{
            setReadOnly(true);
        }
    };
      

    // 渲染页面内容
    return (
      <div className="App">
        <Header />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '95%', margin: 'auto' }}>
            <Typography variant="h4" sx={{ textAlign: 'left', mt: 3, mb: 3 }}>
                我的帳號
            </Typography>
        </div>
        <Box>
            { formData ? (
                <Container maxWidth="md" sx={{ mt: 3 }}>  
                    <form id="accountForm" onSubmit={handleProfileChange}>
                        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>姓名：</Typography>
                            <TextField id="fullName" name="fullName"  variant="standard"
                                label={idReadOnly ? "" : "輸入姓名" }
                                defaultValue={formData.fullName ? formData.fullName : formData.fullname}
                                onChange={handleInputChange}
                                InputProps={idReadOnly ? {readOnly: true} : {}}
                                required
                            />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>email：</Typography>
                            <TextField id="email" name="email" variant="standard" type="email" 
                                label={idReadOnly ? "" : "輸入email" }
                                defaultValue={formData.username}
                                onChange={handleInputChange}
                                InputProps={idReadOnly ? {readOnly: true} : {}}
                                required
                            />
                        </div>
                        {formData.companyName && (
                            <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                                <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>公司名稱：</Typography>
                                <TextField id="companyName" name="companyName"   variant="standard" sx={{ mt: 2 }}
                                    value={formData.companyName}
                                    InputProps={{readOnly: true}}
                                />
                            </div>
                        )}
                        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>統編：</Typography>
                            <TextField id="companyId" name="companyId"   variant="standard" sx={{ mt: 2 }}
                                value={formData.companyId}
                                InputProps={{readOnly: true}}
                            />
                        </div>
                        
                        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>剩餘固定點數：</Typography>
                            <TextField id="regularPoints" name="regularPoints" variant="standard" type="number" sx={{ mt: 2 }}
                                value={formData.regularPoints}
                                InputProps={{readOnly: true}}
                            />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>剩餘額外點數：</Typography>
                            <TextField id="bonusPoints" name="bonusPoints" variant="standard" type="number" sx={{ mt: 2 }}
                                value={formData.bonusPoints}
                                InputProps={{readOnly: true}}
                            />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>創立日期：</Typography>
                            <TextField id="createdAt" name="createdAt" variant="standard" sx={{ mt: 2 }}
                                value={formData.createdAt}
                                InputProps={{readOnly: true}}
                            />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>最後登入時間：</Typography>
                            <TextField id="loginAt" name="loginAt" variant="standard" sx={{ mt: 2 }}
                                value={formData.loginAt}
                                InputProps={{readOnly: true}}
                            />
                        </div>
                        {idReadOnly ? (
                            <Button component="label" variant="contained" color="primary" sx={{ mt: 3 }} onClick={() => handleModify(true)}>
                                點擊修改
                            </Button>
                        ) : (
                            <div>
                                <Button component="label" variant="contained" color="primary" sx={{ mt: 3, mr: 2 }} onClick={() => handleModify(false)}>
                                    取消
                                </Button>
                                <Button type="submit" variant="contained" color="success" sx={{ mt: 3 }}>
                                    存檔&送出
                                </Button>
                            </div>
   
                        )}
                        
                    </form>
                </Container>
            ) : (
                <Typography>讀取中...</Typography>
            )}
            
        </Box>
      </div>
    );
  }
  
  export default FormPage;